import {
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_REQUEST,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_FAILURE,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_CLEAR,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_QUEUE,
} from '../../../actions/actionTypes'

import fetchStatusReducerCreator from '../../fetchStatuses/higherOrderReducers/reducerCreators'

export default fetchStatusReducerCreator({})(
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_REQUEST,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_FAILURE,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_CLEAR,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_QUEUE
)
